// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"86a04e4d","406":"8fa001d7"}[chunkId] + ".chunk.css";
};